// PREFIX: MODULE/VIEW
const PREFIX = 'PAYSBILL/REDUX';

// BUSINESS ACTIONS
export const RESTAURANT = `${PREFIX}/RESTAURANT`;
export const FRANCHISEE = `${PREFIX}/FRANCHISEE`;
export const SEARCHPARAMS = `${PREFIX}/SEARCHPARAMS`;
